import { useContext, useState } from "react";
import styles from "./RegenButton.module.scss";
import { MdRefresh } from "react-icons/md";
import { TiWarningOutline } from "react-icons/ti";

import {
  Dialog,
  DialogClose,
  DialogContent,
  DialogTrigger,
  useDialogContext,
} from "@/components/ui/Dialog/Dialog";
import Button from "@/components/ui/buttons/Button/Button";

export default function RegenButton({ section, slug }) {
  return (
    <Dialog>
      <DialogTrigger
        className={`${styles.regenButton} wn-guide-regen-button`}
        id="wn-itinerary-regen-button"
        title="Regenerate this section"
      >
        <MdRefresh size={20} />
      </DialogTrigger>
      <DialogContent className={`${styles.dialogContent}`}>
        <RegenWarning section={section} slug={slug} />
      </DialogContent>
    </Dialog>
  );
}

function RegenWarning({ section, slug }) {
  const { setOpen } = useDialogContext();
  const [isLoading, setIsLoading] = useState(false);
  const [success, setSuccess] = useState(false);

  const handleSectionRegen = async () => {
    setIsLoading(true);
    try {
      const response = await fetch("/api/travel-guide/generate/regen", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          slug,
          parts: { [section]: true },
        }),
      });

      const data = await response.json();

      setSuccess(true);

      return true;
    } catch (error) {
      console.error(error);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className={`${styles.regenWarning}`}>
      <div className={`${styles.textContainer}`}>
        {!success && (
          <>
            <TiWarningOutline size={60} />
            <p className={`${styles.text}`}>
              Clicking &apos;Continue&apos; will regenerate this section. Are
              you sure you want to delete the old section and create a new one?
            </p>
          </>
        )}
        {success && (
          <>
            <TiWarningOutline size={60} />
            <p className={`${styles.text}`}>
              This section is now being regenerated! Check back in a few minutes
              to see the new one.
            </p>
          </>
        )}
      </div>
      <div className={`${styles.buttonContainer}`}>
        {!success && (
          <>
            <Button
              fill="light"
              onClick={() => setOpen(false)}
              disabled={isLoading}
            >
              Cancel
            </Button>
            <Button onClick={handleSectionRegen} loading={isLoading}>
              Continue
            </Button>
          </>
        )}
        {success && (
          <Button fill="dark" onClick={() => setOpen(false)}>
            Okay
          </Button>
        )}
      </div>
    </div>
  );
}
